import React from 'react';
import './index.css';

function Select (props) {

    const {children, ...other} = props;

    return (
        <select className="custom-select" {...other}>
            {children}
        </select>
    )
}

export default Select;